export default __webpack_public_path__ + "static/money-6506a286d879748bec6931242f2b9d0a.png";